import { Link } from 'react-router-dom';
import ModernNavigation from '@/components/ModernNavigation';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Zap, Battery, Gauge, Shield, ArrowRight } from 'lucide-react';

const VelosElectriques = () => {
  return (
    <div className="min-h-screen bg-background">
      <ModernNavigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-emerald-50 to-white py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="inline-flex items-center bg-emerald-100 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
              <Zap className="w-4 h-4 mr-2" />
              Vélos électriques
            </div>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
              Location de vélos électriques
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profitez de l'assistance électrique pour explorer sans effort les plus beaux paysages de la côte atlantique
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Battery className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Autonomie 80 km</h3>
                <p className="text-sm text-gray-600">Batterie longue durée pour vos longues balades</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Gauge className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">3 niveaux d'assistance</h3>
                <p className="text-sm text-gray-600">Adaptez l'assistance à votre effort</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Shield className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Vélos récents</h3>
                <p className="text-sm text-gray-600">Flotte renouvelée régulièrement</p>
              </CardContent>
            </Card>

            <Card className="border-0 shadow-lg text-center">
              <CardContent className="p-6">
                <Zap className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
                <h3 className="font-bold text-gray-900 mb-2">Recharge incluse</h3>
                <p className="text-sm text-gray-600">Chargeur fourni avec le vélo</p>
              </CardContent>
            </Card>
          </div>

          {/* Description */}
          <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Pourquoi choisir un vélo électrique ?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Idéal pour tous</h3>
                <p className="text-gray-700">
                  L'assistance électrique permet à chacun de profiter du vélo, quel que soit son niveau de forme physique. Parfait pour les familles avec enfants ou les groupes de niveaux différents.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Parcourez plus de distance</h3>
                <p className="text-gray-700">
                  Avec une autonomie de 80 km, explorez l'ensemble de votre destination sans fatigue. Idéal pour découvrir plusieurs villages en une journée.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Confort optimal</h3>
                <p className="text-gray-700">
                  Nos vélos électriques sont équipés de selles confortables, de porte-bagages et de paniers pour transporter vos affaires de plage.
                </p>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-2">Écologique</h3>
                <p className="text-gray-700">
                  Déplacez-vous de manière écologique tout en profitant d'une assistance pour les montées et le vent de face.
                </p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center">
            <Link to="/reserver">
              <Button className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-8 py-3 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all">
                <Zap className="w-5 h-5 mr-2" />
                Réserver un vélo électrique
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VelosElectriques;